import { render } from "./BlCollectionRemove.vue?vue&type=template&id=5de9a7a5&scoped=true"
import script from "./BlCollectionRemove.vue?vue&type=script&lang=js"
export * from "./BlCollectionRemove.vue?vue&type=script&lang=js"

import "./BlCollectionRemove.vue?vue&type=style&index=0&id=5de9a7a5&scoped=true&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de9a7a5"]])

export default __exports__